import Footer from "./Components/Footer";
import Content from "./Components/content";
import Header from "./Components/headers";
import './index.css'


function App() {
  return (
    <main className="w-full 2xl:container 2xl:mx-auto flex-w">
      <Header />
      <Content/>
      <Footer/>
    </main>
  )
}

export default App;
